import {
  TKardexCost,
  type BaseServiceOptions,
  type Pagination,
  type TBaseWarehouse,
} from '@/core/types'
import {
  moduleServiceHandlers,
  catalogServiceHandlers,
  type THistories,
  serviceConfig,
} from '../../..'
import { defaultPagination, useNotification } from '@/core'
import { useQuery } from '@tanstack/vue-query'
import { AxiosError } from 'axios'
import { TArticle } from '@/modules/purchase-orders'

const { model } = serviceConfig

export const useModuleQuery = (options: BaseServiceOptions<Pagination>) => {
  const { currentPage, handlers, modelId, filters, enableQuery } = options

  const { errorHttpNotification } = useNotification()

  const loadRecords = useQuery<THistories, AxiosError>({
    queryKey: [model, currentPage, filters?.loadRecords],
    queryFn: () =>
      moduleServiceHandlers.loadRecords({
        dynamicFilters: filters?.loadRecords,
        page: currentPage,
      }),
    refetchOnWindowFocus: false,
    enabled: enableQuery?.loadRecords,
    onError: (error) => errorHttpNotification(error),
    onSuccess: (data) => {
      if (data?.meta) {
        handlers?.onDataChange?.(data.meta ?? defaultPagination)
      }
    },
  })

  const warehouseCatalog = useQuery<TBaseWarehouse[]>(
    [serviceConfig.catalogs.warehouse],
    () => catalogServiceHandlers.warehouseCatalog.loadCatalog({}),
    {
      refetchOnWindowFocus: false,
      enabled: enableQuery?.warehouseCatalog,
    },
  )

  const articlesCatalog = useQuery<TArticle[], AxiosError>({
    queryKey: [serviceConfig.catalogs.articles, filters?.articlesCatalog],
    queryFn: () =>
      catalogServiceHandlers.articlesCatalog.loadCatalog({
        dynamicFilters: filters?.articlesCatalog,
      }),
    refetchOnWindowFocus: false,
    enabled: enableQuery?.articlesCatalog,
  })

  const loadRecord = useQuery<TKardexCost, AxiosError>({
    queryKey: [model, modelId],
    queryFn: ({ queryKey }) => {
      return moduleServiceHandlers.loadRecord({
        id: Number(queryKey[1]),
      })
    },
    refetchOnWindowFocus: false,
    enabled: enableQuery?.loadRecord,
    onError: (error) => errorHttpNotification(error),
  })

  return {
    loadRecords,
    loadRecord,
    warehouseCatalog,
    articlesCatalog,
  }
}
